/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { oauth_credentials } from '../models/oauth_credentials';
import type { social_information } from '../models/social_information';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Request `Member` oauth access token, to be able to authenticate a member before executing actions with this account.
     *
     * @param infos
     * @returns oauth_credentials Successful operation, returning authentication credential.
     * @throws ApiError
     */
    public static postMembersAuthentication(
        infos?: {
            /**
             * Member Email (Required if member identifier is not provided)
             */
            email?: string;
            /**
             * Member Identifier (Required if email is not provided)
             */
            member_id?: number;
            /**
             * Member Password (Required to receive a refresh token and an access token). Please use refresh token if you already retrieved it.
             */
            password?: string;
            /**
             * Member Token (Required to securly authenticate a member without password).
             */
            refresh_token?: string;
        },
    ): CancelablePromise<oauth_credentials> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/authentication',
            body: infos,
        });
    }
    /**
     * Request `Member` oauth access token from social credentials.
     *
     * @param infos
     * @returns oauth_credentials Successful operation, returning authentication credential.
     * @throws ApiError
     */
    public static postMembersSocialAuthentication(
        infos?: social_information,
    ): CancelablePromise<oauth_credentials> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/social_authentication',
            body: infos,
        });
    }
    /**
     * Request `Member` oauth access token, to be able to authenticate a member before executing actions with this account. If member doesn't exist, creates an account.
     *
     * @param infos
     * @returns oauth_credentials Successful operation, returning authentication credential.
     * @throws ApiError
     */
    public static postMembersCryptedAuthentication(
        infos?: {
            /**
             * Encrypted Email (Required if holder_ref is not provided)
             */
            email?: string;
            /**
             * Retailer Identifier (Required to authenticate with holder_ref)
             */
            retailer_id?: number;
            /**
             * Encrypted Holder ref (Required if member_email is not provided)
             */
            holder_ref?: string;
            /**
             * Flag to identify Register User or not (Default value is true if not provided)
             */
            register_user?: boolean;
            /**
             * Encrypted Line ref (Required if member_email or holder ref is not provided)
             */
            line_id?: string;
            /**
             * Encrypted app id  (Required if member_email or holder ref or line id is not provided)
             */
            app_id?: string;
            /**
             * Inqury number in encrypted form
             */
            inquiry_number_hash?: string;
        },
    ): CancelablePromise<oauth_credentials> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/crypted_authentication',
            body: infos,
        });
    }
}
